import React from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';
import { isValidURL } from 'utils/string_utils';

class ExternalLink extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      externalLink: props.updating
        ? props.externalLink
        : { url: '', title: '', description: '' },
      errorMessage: {},
    };
    this.handleInput = this.handleInput.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.delete = this.delete.bind(this);
    this.hasValidFields = this.hasValidFields.bind(this);
  }

  handleInput(e, state) {
    const { value } = e.target;
    this.setState(
      currentState => ({
        externalLink: {
          ...currentState.externalLink,
          [state]: value,
        },
      }),
      this.validate(value, state),
    );
  }

  validate(value, state) {
    let message = '';

    if (value.trim().length === 0) {
      message = 'Required';
    } else if (state === 'url' && !isValidURL(value)) {
      message = 'Invalid URL';
    }

    this.setState(currentState => ({
      errorMessage: {
        ...currentState.errorMessage,
        [state]: message,
      },
    }));
  }

  handleSave(field) {
    if (!this.hasValidFields()) return;

    if (this.props.updating) {
      this.props.updateMapping(this.state.externalLink, field);
    } else {
      this.props.addNewExternalLinkMapping(this.state.externalLink);
    }
  }

  hasValidFields() {
    let valid = true;
    const { externalLink } = this.state;

    // eslint-disable-next-line no-restricted-syntax
    for (const field in externalLink) {
      if (!externalLink[field]) {
        valid = false;
        break;
      }
    }

    if (!isValidURL(externalLink.url)) valid = false;

    return valid;
  }

  delete() {
    if (this.props.updating) {
      this.props.deleteMapping(this.state.externalLink);
    } else {
      this.props.setRelatedContentType();
    }
  }

  render() {
    const { i18n, updating, externalLink } = this.props;
    const fields = {
      url: 'url',
      title: 'title',
      description: 'description',
    };

    const errorField = errorMessage => (
      <div className="mt-4 c-brand-red">{errorMessage}</div>
    );

    return (
      <div className="FlexboxTable-row">
        <div className="FlexboxTable-cell">
          <div className="d-f jc-sb ai-c">
            <div className="ExternalLink f-1 mr-24">
              <div className="mb-12">
                <div className="mb-8">
                  <span className="HelpText HelpText--muted">
                    {i18n.external_link.hyperlink}
                  </span>
                </div>
                <input
                  className={classNames(
                    'NewInput NewInput--white NewInput--fw',
                    {
                      'ExternalLink--error': this.state.errorMessage.url,
                    },
                  )}
                  placeholder={i18n.external_link.hyperlink_placeholder}
                  defaultValue={updating ? externalLink[fields.url] : ''}
                  onChange={e => this.handleInput(e, fields.url)}
                  onBlur={() => this.handleSave(fields.url)}
                  type="text"
                />
                {this.state.errorMessage.url &&
                  errorField(this.state.errorMessage.url)}
              </div>
              <div className="mb-12">
                <div className="mb-8">
                  <span className="HelpText HelpText--muted">
                    {i18n.external_link.title}
                  </span>
                </div>
                <input
                  className={classNames(
                    'NewInput NewInput--white NewInput--fw',
                    {
                      'ExternalLink--error': this.state.errorMessage.title,
                    },
                  )}
                  placeholder={i18n.external_link.title_placeholder}
                  defaultValue={updating ? externalLink[fields.title] : ''}
                  onChange={e => this.handleInput(e, fields.title)}
                  onBlur={() => this.handleSave(fields.title)}
                  type="text"
                />
                {this.state.errorMessage.title &&
                  errorField(this.state.errorMessage.title)}
              </div>
              <div className="mb-12">
                <div className="mb-8">
                  <span className="HelpText HelpText--muted">
                    {i18n.external_link.description}
                  </span>
                </div>
                <textarea
                  className={classNames(
                    'NewInput NewInput--white NewInput--fw',
                    {
                      'ExternalLink--error':
                        this.state.errorMessage.description,
                    },
                  )}
                  placeholder={i18n.external_link.description_placeholder}
                  defaultValue={
                    updating ? externalLink[fields.description] : ''
                  }
                  onChange={e => this.handleInput(e, fields.description)}
                  onBlur={() => this.handleSave(fields.description)}
                />
                {this.state.errorMessage.description &&
                  errorField(this.state.errorMessage.description)}
              </div>
            </div>
            <div className="IndexAction-container">
              <button
                type="button"
                className="ButtonWithTooltip IndexAction-button IndexAction-button--square"
                onClick={this.delete}
                onKeyDown={e => e.key === 'Enter' && this.delete()}
                data-tooltip="Delete Mapping"
              >
                <Icon name="delete" />
              </button>
            </div>
          </div>
          <div className="HelpText HelpText--muted">
            <Icon name="group" />
            <span>{i18n.everyone_group}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default ExternalLink;
